<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title">
        {{title}}
    </div>
    <div class="nova__dialog__toolbar__controls">
        <button class="nova__button--icon">
            <mat-icon class="nova-toolbar__controls__icon--close" [mat-dialog-close]="getResult(true)">close</mat-icon>
        </button>
    </div>
</div>
<div mat-dialog-content class="nova__dialog__content dialog-content">
    <mat-form-field class="text-area-field">
    <textarea [(ngModel)]="note" matInput [maxlength]="maxLength" [readonly]="readonly"
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        [cdkAutosizeMinRows]="6"
        [cdkAutosizeMaxRows]="105"
        (ngModelChange)="noteChanged()"
        placeholder="Type your note here"></textarea>
    </mat-form-field>
    <div class="space-between">
        <div *ngIf="hasValidationErrors" class="error">Max limit {{ maxLength }} characters</div>
        <div class="spacer"></div>
        <mat-hint>{{ note?.length ? note.length : 0 }}/{{ maxLength }}</mat-hint>
    </div>
    <ng-container *ngIf="needToAttachToDocument">
        <mat-divider class="divider"></mat-divider>
        <div>
            Which document is this note for?
        </div>
        <mat-form-field class="nova__input document-search-field" appearance="outline">
            <input matInput type="text" placeholder="Search a doc type or doc name" [formControl]="docSearch">
        </mat-form-field>
        <div class="table-container">
                <table mat-table aria-hidden="true" class="nova__table" [dataSource]="documents">
                    <ng-container matColumnDef="select">
                        <th id="select" mat-header-cell *matHeaderCellDef>
                            <mat-checkbox (change)="$event ? masterToggle() : null" color="primary"
                                [checked]="selection.hasValue() && isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox class="checkbox-cell" (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                                [checked]="selection.isSelected(row)" color="primary">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="docCategory">
                        <th id="docCategory" mat-header-cell *matHeaderCellDef>Doc Category > Type</th>
                        <td mat-cell *matCellDef="let document; let i = index;">
                                <span *ngIf="document?.category && !document?.type">
                                    {{ document?.category }} > N/A
                                </span>
                                <span *ngIf="document?.category && document?.type">
                                    {{ document?.category }} > {{ document?.type }}
                                </span>
                                <span *ngIf="!document?.category && !document?.type">
                                    N/A
                                </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="isAssigned">
                        <th id="isAssigned" mat-header-cell *matHeaderCellDef>Is Assigned</th>
                        <td mat-cell *matCellDef="let document">
                            <mat-icon inline="true" *ngIf="document?.isAssigned">done</mat-icon>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="docName">
                        <th id="docName" mat-header-cell *matHeaderCellDef>Doc Name</th>
                        <td mat-cell *matCellDef="let document">
                            <a class="nova__link" (click)="showFile(document?.documentId)">
                                {{ document?.name || 'N/A' }}
                            </a>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="percent">
                        <th id="percent" mat-header-cell *matHeaderCellDef>%</th>
                        <td mat-cell *matCellDef="let document">
                            <span>{{ document?.percent }}%</span>
                        </td>
                    </ng-container>

                    <tr mat-header-row class="header-row" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
        </div>
    </ng-container>
    <div class="justify-end">
    <mat-dialog-actions class="nova__dialog__content__actions" *ngIf="!readonly">
        <button mat-flat-button color="primary" [mat-dialog-close]="getResult()"
            [disabled]="isSaveDisabled()">{{saveBtnText}}</button>
        <button mat-flat-button color="cancel" [mat-dialog-close]="getResult(true)">CANCEL</button>
    </mat-dialog-actions>
    </div>
</div>
